import { Box, ButtonGroup, Toolbar } from '@mui/material'
import type { SearchResultDisplay, SearchResultWidth } from '../types'
import { AddNotificationButton } from './actions/AddNotificationButton'
import { CopyLinkButton } from './actions/CopyLinkButton'
import { ExportResultsButton } from './actions/ExportResultsButton'
import { ResultDisplay } from './actions/ResultDisplay'
import { SelectionActions } from './actions/SelectionActions'
import { ViewWidth } from './actions/ViewWidth'

type Props = {
  view: SearchResultDisplay
  width: SearchResultWidth
  setWidth: (fullWidth: SearchResultWidth) => void
  setView: (view: SearchResultDisplay) => void
}

export const SearchResultsBar = (props: Props) => {
  const { view, width, setWidth, setView } = props
  return (
    <Toolbar disableGutters variant="dense" sx={{ gap: 3, my: 0.5 }}>
      <ResultDisplay
        size="small"
        value={view}
        onChange={(_event, value) => {
          setView(value)
        }}
      />
      <SelectionActions />
      <Box marginLeft="auto" />

      <ButtonGroup color="secondary" variant="outlined">
        <CopyLinkButton />
        <AddNotificationButton />
        <ExportResultsButton />
      </ButtonGroup>

      <ViewWidth
        size="small"
        value={width}
        onChange={(_event, value) => setWidth(value)}
      />
    </Toolbar>
  )
}
